import React, { type ReactElement } from 'react'
import {
  FieldError,
  type FieldValues,
  type Path,
  type UseFormRegister,
} from 'react-hook-form'
import Label from './Label'
import Input, { InputProps } from './Input'

type InputFieldProps<TFieldValues extends FieldValues> = {
  label: string
  register: UseFormRegister<TFieldValues>
  error?: FieldError
  name: Path<TFieldValues>
} & InputProps<TFieldValues>

export default function InputField<TFieldValues extends FieldValues>({
  label,
  register,
  name,
  ...props
}: InputFieldProps<TFieldValues>): ReactElement {
  return (
    <div>
      <Label htmlFor={name} label={label} />
      <div className="mt-2">
        <Input register={register} name={name} {...props} />
      </div>
    </div>
  )
}

InputField.defaultProps = {
  type: 'text',
}
